import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    IconButton
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import styled from "styled-components";
import { BUTTON_LABELS } from "./messages";

const StyledDialogTitle = styled(DialogTitle)`
  position: relative;
  display: flex;
  align-items: center;
  padding: 16px 24px;
  background-color: #F1F4F9;
  color: red;
  border-bottom: 1px solid #A0B1C5;
`;

const StyledCancelButton = styled(Button)`
  border-color: #0b7474 !important;
`;

const WarningDialog = ({
  open,
  onCancel,
  onConfirm,
  message,
  cancelLabel = BUTTON_LABELS.CANCEL,
  confirmLabel = BUTTON_LABELS.OK,
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onCancel} 
      disablePortal={false}
      disableEnforceFocus={false}
      disableAutoFocus={false}
      disableRestoreFocus={false}
      maxWidth="sm"
      fullWidth
      aria-labelledby="warning-dialog-title"
      aria-describedby="warning-dialog-description"
    >
      <StyledDialogTitle id="warning-dialog-title">
        <span role="img" aria-label="warning" style={{ marginRight: '8px' }}>
          ⚠️
        </span>
        <span>
          Warning!
        </span>
        <IconButton 
          onClick={onCancel} 
          size="small" 
          style={{ 
            position: 'absolute', 
            right: '24px', 
            top: '50%', 
            transform: 'translateY(-50%)' 
          }}
        >
          <CloseIcon />
        </IconButton>
      </StyledDialogTitle>
      <DialogContent>
        <Typography align="justify" id="warning-dialog-description">
          {message}
        </Typography>
      </DialogContent>
      <DialogActions style={{ justifyContent: 'space-between', padding: '16px 24px' }}>
        <StyledCancelButton onClick={onCancel} color="primary" variant="outlined">
          {cancelLabel}
        </StyledCancelButton>
        <Button onClick={onConfirm} color="primary" variant="contained">
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WarningDialog;
